import Vue from 'vue'
import { localize } from 'vee-validate'
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  // setInteractionMode,
} from 'vee-validate'
import {
  required,
  email,
  confirmed,
  min,
  max,
  integer,
  min_value,
} from 'vee-validate/dist/rules'
import numeral from 'numeral'

// Definiert wie sich die Vaildierung verhalten soll.
// https://logaretm.github.io/vee-validate/guide/interaction-and-ux.html#custom-modes
// setInteractionMode('eager')

Vue.component('validation-observer', ValidationObserver)
Vue.component('validation-provider', ValidationProvider)

// TODO: vee-validate and vue-i18n
import de from 'vee-validate/dist/locale/de.json'

// Installs the translations provided by vee-validate.
// Sets the default translation.
localize('de', de)

// Import required vaildations.
extend('required', required)
extend('email', email)
extend('confirmed', confirmed)
extend('integer', integer)
extend('min', min)
extend('max', max)
extend('min_value', min_value)

// TODO: Nach common/validations verschieben.
// Oder: common validations hier her integrieren.

extend('decimal', {
  validate(value) {
    if (value == null || value == undefined) {
      return false
    }

    if (Number.isFinite(value)) {
      return true
    }

    if (value[0] === '+' || value[0] === '-') {
      return numeral.validate(value.substring(1), 'en')
    }
    return numeral.validate(value, 'en')
  },
  message: 'The {_field_} field must contain only decimal values',
})

// extend('daterange', {
//   params: ['start'],
//   // @ts-ignore
//   validate(value, { start }) {
//     if (
//       moment(moment(value).format('YYYY-MM-DD')).isAfter(
//         moment(moment(start).format('YYYY-MM-DD'))
//       )
//     ) {
//       return true
//     }

//     return false
//   },
//   message: 'This field value must be after {target}',
// })

// NOTE: Add more validation rules here.
